import React from 'react';

const TpaMaster = () => {
    return (
        <div>
            <h1>TpaMaster</h1>
        </div>
    );
};

export default TpaMaster;
